export function showSaveAsCompanyEmail({
  companyEmail,
  enteredEmail,
  canEditCrmRecord,
}: {
  companyEmail: string | null;
  enteredEmail: string;
  canEditCrmRecord: boolean;
}): boolean {
  return (
    canEditCrmRecord && !!companyEmail && !sameEmail(companyEmail, enteredEmail)
  );
}

export function shouldWriteCompanyEmail({
  companyEmail,
  enteredEmail,
  saveAsCompanyEmail,
  canEditCrmRecord,
}: {
  companyEmail: string | null;
  enteredEmail: string;
  saveAsCompanyEmail: boolean;
  canEditCrmRecord: boolean;
}): boolean {
  if (!canEditCrmRecord) return false;
  if (!companyEmail) return true;
  return saveAsCompanyEmail && !sameEmail(companyEmail, enteredEmail);
}

function sameEmail(a: string, b: string): boolean {
  return a.trim().toLowerCase() === b.trim().toLowerCase();
}
